<template>
  <div class="info">
    <span class="icon-info info__icon"></span>
    <div class="info__message">{{ message }}</div>
    <span class="icon-cancel-circle info__close" @click="closeInfo"></span>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      required: true,
    },
  },
  methods: {
    closeInfo() {
      this.$el.style.display = 'none';
    },
  },
};
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
